import { useEffect, useState } from 'react';
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import EditForm from '../../utils/utilities/EditForm';

import { Grid } from '@mui/material';

import { fields, initialValues, schema, additionalState, parseData } from './config';

// import Sidebar from './Components/Sidebar';

import useIsMobile from '../../hooks/useIsMobile';

const EditSyncedShipment = () => {
  let { isMobile } = useIsMobile();
  // let sidebar = isMobile ? null : <Sidebar />;
  const [formFields, setFormFields] = useState([...fields.map(field => ({...field}))]);

  return (
    <EditForm title={"NovoTracker Shipment"} initialValues={initialValues} fields={formFields} schema={schema} url={"synced_shipments"} additionalState={additionalState} parseData={parseData}>
      
     </EditForm>
  );
}

export default EditSyncedShipment;